if ( typeof ProductPage !== 'function' ) {

  class ProductPage extends HTMLElement {

    constructor(){
      super();

      this.productGallery = this.querySelector('[data-js-product-gallery]');
      this.productSlider  = this.querySelector('css-slider');
      this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

      // Tabs: allow Enter key to activate
      this.querySelectorAll('[data-js-product-tabs]').forEach(tabs=>{
        tabs.querySelectorAll('label').forEach(tab=>{
          tab.addEventListener('keyup', e=>{
            if ( e.keyCode == window.KEYCODES.RETURN ) tab.click();
          });
        });
      });

      // ----- Gallery / Thumbnails -----
      if ( this.productSlider ) {
        const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

        if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {
          this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
            if ( i == 0 ) elm.classList.add('active');
            elm.addEventListener('click', e=>{
              if ( this.productSlider.sliderEnabled ) {
                this.productSlider.changeSlide(e.currentTarget.dataset.index);
              } else {
                window.scrollTo({
                  top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
                  behavior: 'smooth'
                });
                this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
              }
              this._pauseAllMedia();
              this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
              productGaleryThumbnails.scrollTo({ left: elm.offsetLeft - 50, behaviour: 'smooth' });
            });
          });

          this.productSlider.addEventListener('change', e=>{
            this.thumbnailNavigationHelper(e.target.index);
          });
        }

        this.productSlider.addEventListener('navigation', e=>{
          this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
        });

        this.productSlider.addEventListener('change', e=>{
          this._pauseAllMedia();
          const current = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
          if ( current && current.dataset.productMediaType == 'model' ) {
            if ( this.xrButton ) {
              this.xrButton.setAttribute('data-shopify-model3d-id', current.dataset.mediaId);
            }
            setTimeout(()=>{
              this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
            }, 150);
          }
        });

        // Parallax
        this.productSlider.addEventListener('ready', ()=>{
          this.productImageSlides = this.productSlider.querySelectorAll('.product-gallery-item');
          this.productImages      = this.productSlider.querySelectorAll('.product-media-image');
        });
        this.productSlider.addEventListener('scroll', ()=>{
          const scrollX = -this.productSlider.element.scrollLeft;
          this.productImageSlides.forEach((slide,i)=>{
            const img = this.productImages[i];
            if (!img) return;
            const slideX = slide.offsetLeft;
            img.style.transform = `translateX(${(slideX + scrollX) * -1/3}px)`;
          });
        });

        this.productSlider.addEventListener('ready', (e)=>{
          if ( this.firstProductGalleryIndex ) {
            this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
          }
        });
      }

      this.productGallery.querySelectorAll('[data-js-video-popup-link]').forEach(elm=>{
        elm.addEventListener('click', ()=>{ this._pauseAllMedia(); });
      });

      // ----- Variant events (theme logic) -----
      this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
      if ( this.productVariants ) {
        this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
        this.onVariantChangeHandler({ target: this.productVariants });

        // Refresh color label on click
        this.querySelectorAll('.product-variant__item--radio').forEach(elm=>{
          elm.addEventListener('click', e=>{
            if ( elm.classList.contains('product-variant__item--color' ) ) {
              elm.closest('.product-variant')
                 .querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
            }
          });
        });
      }

      // ----- Show cart drawer once theme adds to cart -----
      if ( !document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
        let addToCartEnter = false;
        this.querySelector('[data-js-product-add-to-cart]')?.addEventListener('keyup', e=>{
          if ( e.keyCode == window.KEYCODES.RETURN ) addToCartEnter = true;
        });

        this.querySelector('[data-js-product-form]')?.addEventListener('add-to-cart', ()=>{
          document.getElementById('site-cart-sidebar').show();
          document.getElementById('cart-recommendations-sidebar')?.generateRecommendations();
          if ( addToCartEnter ) {
            setTimeout(()=>{ document.querySelector('#site-cart-sidebar [data-js-close]').focus(); }, 200);
          }
        });
      }

      // ----- Models / XR -----
      const models = this.querySelectorAll('product-model');
      if ( models.length > 0 ) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector('.product-gallery__view-in-space');
      }

      // ----- Buy button enabled/disabled mirrors "Buy Now" visibility -----
      const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
      if ( addToCartButton ) {
        if ( addToCartButton.classList.contains('disabled') ) {
          this.querySelector('product-form').classList.add('disable-buy-button');
        } else {
          this.querySelector('product-form').classList.remove('disable-buy-button');
        }
        const buyObserver = new MutationObserver(()=>{
          if ( addToCartButton.classList.contains('disabled') ) {
            this.querySelector('product-form').classList.add('disable-buy-button');
          } else {
            this.querySelector('product-form').classList.remove('disable-buy-button');
          }
        });
        buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
      }

      // ----- Truncated descriptions -----
      if ( this.querySelector('[data-js-show-more]') ) {
        const showMore = this.querySelector('[data-js-show-more]');
        const productDescription = this.querySelector('.product__description');
        showMore.addEventListener('click', ()=>{
          productDescription.classList.toggle('product__description--truncated-initial');
          showMore.querySelector('.button__text').textContent = productDescription.classList.contains('product__description--truncated-initial')
            ? showMore.dataset.labelShowLess
            : showMore.dataset.labelShowMore;
        });
      }

      // ----- Recommendations -----
      this.querySelector('product-recommendations')?.addEventListener('product-recommendations-loaded', ()=>{
        this.querySelector('product-recommendations').classList.add('product-text-element--with-borders');
      });
      this.querySelector('product-recommendations')?.addEventListener('product-recommendations-error', ()=>{
        this.querySelector('product-recommendations').remove();
      });
    }

    thumbnailNavigationHelper(index=0){
      this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
        if ( i == index ) elm.classList.add('active'); else elm.classList.remove('active');
      });
    }

    onVariantChangeHandler(e){
      let variant = e.target.currentVariant;
      if ( variant ) {
        // Image handling
        if ( variant.featured_media != null ) {
          let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
          if ( variantImg ) {
            const isSlider = this.productGallery.classList.contains('product-gallery--slider') ||
                             ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 );
            if ( isSlider ) {
              if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
                this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
              } else {
                this.firstProductGalleryIndex = variantImg.dataset.index;
              }
            } else {
              window.scrollTo({ top: variantImg.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
            }
          }
        }

        // Update cart button price once a selectable variant exists
        if ( this.querySelector('product-variants').hasAttribute('data-variant-required') ) {
          this.priceInit = true;
        }
        if ( !this.querySelector('[data-js-product-add-to-cart-text]').hasAttribute('data-show-preorder-wording') ) {
          if ( this.priceInit ) {
            this.querySelector('[data-js-product-add-to-cart-text]').innerHTML =
              `${this.querySelector('[data-js-product-add-to-cart-text]').innerHTML}${
                (variant.available ? `<span class="button__price"> - ${this.querySelector('[data-js-product-price-original]').innerHTML}</span>` : ``)
              }`;
          }
          this.priceInit = true;
        }
      }
      this._pauseAllMedia();
    }

    _pauseAllMedia(){
      document.querySelectorAll('.product-gallery .js-youtube')
        .forEach(video => video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
      document.querySelectorAll('.product-gallery .js-vimeo')
        .forEach(video => video.contentWindow.postMessage('{"method":"pause"}', '*'));
      document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
      document.querySelectorAll('.product-gallery product-model').forEach(model => {
        if ( model.modelViewerUI && model.modelViewerUI.pause ) model.modelViewerUI.pause();
      });
    }

    _playMedia(media){
      switch ( media.dataset.productMediaType ) {
        case 'video':
          media.querySelector('video')?.play();
          break;
        case 'external_video-youtube':
          media.querySelector('.js-youtube')?.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          break;
        case 'external_video-vimeo':
          media.querySelector('.js-vimeo')?.contentWindow.postMessage('{"method":"play"}', '*');
          break;
      }
    }
  }

  if ( typeof customElements.get('product-page') == 'undefined' ) {
    customElements.define('product-page', ProductPage);
  }
}

/* --------------------------------------------------------------------------
   MISE — Variant Preselect & Gallery Sync (safe, idempotent)
   - Honors ?variant=… or existing selection; otherwise picks first available
   - Updates hidden input[name="id"], checks swatch radios, dispatches 'change'
   - Syncs featured media; emits 'mi:variant-ready' when done
--------------------------------------------------------------------------- */
(function miseVariantPreselect(){
  const section = document.querySelector('product-page, [id^="shopify-section-"]') || document;
  if (!section || section.dataset.miseVPreInit === '1') return;
  section.dataset.miseVPreInit = '1';

  const by  = (s, c=section) => c.querySelector(s);
  const all = (s, c=section) => Array.from(c.querySelectorAll(s));
  const fire = (el, type='change') => el && el.dispatchEvent(new Event(type, { bubbles: true }));

  // Try product JSON from Dawn-like markup; fallback to window.shoeProductData (your upsell sets this)
  let productData = null;
  const jsonEl = by('script[type="application/json"][data-product-json]');
  if (jsonEl) { try { productData = JSON.parse(jsonEl.textContent); } catch(_){} }
  if (!productData && window.shoeProductData) productData = window.shoeProductData;
  if (!productData || !productData.variants?.length) return;

  const form   = by('product-form form, form[action*="/cart/add"]');
  const idInput = form ? by('input[name="id"]', form) : null;

  // Detect existing selection
  const url = new URL(location.href);
  const urlVariantId = url.searchParams.get('variant') ? Number(url.searchParams.get('variant')) : null;
  const anyChecked = !!by('input[type="radio"][name^="options"]:checked');

  // If the page is already in a selected state, don’t reset it
  if (urlVariantId || anyChecked || (idInput && idInput.value)) {
    section.dispatchEvent(new CustomEvent('mi:variant-ready', { bubbles: true }));
    return;
  }

  // Choose a sane default: first available, else first
  const firstAvailable = productData.variants.find(v => v.available) || productData.variants[0];
  if (!firstAvailable) return;

  // Update hidden id input
  if (idInput && String(idInput.value) !== String(firstAvailable.id)) {
    idInput.value = firstAvailable.id;
    fire(idInput, 'change');
  }

  // Map options -> radios (handles either [data-option-index] or [data-option-position])
  function checkOption(pos, val){
    if (!val) return;
    const radios = all(
      `[data-option-index="${pos}"] input[type="radio"],` +
      `[data-option-position="${pos}"] input[type="radio"],` +
      `input[type="radio"][name="options[${pos}]"],` +
      `input[type="radio"][data-index="${pos}"]`
    );
    const m = radios.find(r => (r.value || r.getAttribute('data-value') || '').toLowerCase().trim() === String(val).toLowerCase().trim());
    if (m && !m.checked) { m.checked = true; fire(m, 'change'); }
  }

  checkOption(1, firstAvailable.option1);
  checkOption(2, firstAvailable.option2);
  checkOption(3, firstAvailable.option3);

  // Put the chosen variant in the URL so back/forward preserves state (optional)
  try {
    const next = new URL(location.href);
    next.searchParams.set('variant', firstAvailable.id);
    history.replaceState({}, '', next);
  } catch(_) {}

  // Sync media/gallery to featured media
  const mediaId = firstAvailable.featured_media && (firstAvailable.featured_media.id || firstAvailable.featured_media.media_id);
  if (mediaId) {
    const thumbBtn = by(`[data-media-id="${mediaId}"] button, button[data-media-id="${mediaId}"]`);
    if (thumbBtn) thumbBtn.click();
    else {
      const slide = by(`[id*="Slide-"][data-media-id="${mediaId}"]`) || by(`[data-media-id="${mediaId}"]`);
      if (slide?.scrollIntoView) slide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  // Let theme/scripts react after preselect
  section.dispatchEvent(new CustomEvent('mi:variant-ready', { bubbles: true }));
})();